(function () {
  const ALWAYS_SHOW_FILTERS = window.alwaysShowFilterValues || {};

  function getCurrentFilters() {
    const current = {};
    document.querySelectorAll('.sidebarBlock.js-filter[data-type-list="true"]').forEach(block => {
      const heading = block.querySelector('.facets__text');
      if (!heading) return;
      const label = heading.textContent.trim();
      if (!ALWAYS_SHOW_FILTERS[label]) return;
      current[label] = { block, values: [] };
      block.querySelectorAll('.facets__item input[type="checkbox"]').forEach(input => {
        current[label].values.push(input.value);
      });
    });
    return current;
  }

  function injectMissingValues(label, allValues, existing) {
    if (existing) {
      const ul = existing.block.querySelector('.facets__list');
      if (!ul) return;
      allValues.forEach(val => {
        if (existing.values.includes(val)) return;
        const id = `Filter-always-${label}-${val}`.replace(/[\s\/]/g, '-');
        const li = document.createElement('li');
        li.className = 'list-menu__item facets__item';
        li.innerHTML = `
          <input type="checkbox" value="${val}" id="${id}" disabled>
          <label for="${id}" class="facet-checkbox facet-checkbox--disabled form-label--checkbox">
            ${val} <span class="count">(0)</span>
          </label>`;
        ul.appendChild(li);
      });
    } else {
      const wrapper = document.querySelector('.collection-filters__item.facets__wrapper');
      if (!wrapper) return;

      const hasCollapse = document.querySelector('.sidebarBlock-headingWrapper') !== null;
      const isExpanded = document.querySelector('.sidebarBlock-heading.is-clicked') !== null;
      const idPrefix = `Filter-always-${label}`.replace(/[\s\/]/g, '-');

      const div = document.createElement('div');
      div.className = 'sidebarBlock js-filter';
      div.setAttribute('data-type-list', 'true');
      div.setAttribute('data-index', '998');
      div.setAttribute('data-always-injected', 'true');

      div.innerHTML = `
        ${hasCollapse ? `<div class="sidebarBlock-headingWrapper">` : ''}
          <h2 class="sidebarBlock-heading${isExpanded ? ' is-clicked' : ''}">
            <span class="facets__text">${label}</span>
            <span class="facets__count" aria-hidden="true"></span>
          </h2>
        ${hasCollapse ? `</div>` : ''}
        ${hasCollapse ? `<div class="sidebarBlock-contentWrapper"${isExpanded ? ' style="display:block;"' : ''}>` : ''}
          <div class="sidebarBlock-content sidebarBlock-content--full facets__display">
            <ul class="facets__list custom-scrollbar list-unstyled" role="list">
              ${allValues.map(val => {
                const id = `${idPrefix}-${val}`.replace(/[\s\/]/g, '-');
                return `<li class="list-menu__item facets__item">
                  <input type="checkbox" value="${val}" id="${id}" disabled>
                  <label for="${id}" class="facet-checkbox facet-checkbox--disabled form-label--checkbox">
                    ${val} <span class="count">(0)</span>
                  </label>
                </li>`;
              }).join('')}
            </ul>
          </div>
        ${hasCollapse ? `</div>` : ''}`;

      const noscript = wrapper.querySelector('noscript');
      noscript ? wrapper.insertBefore(div, noscript) : wrapper.appendChild(div);
    }
  }

  function init() {
    const filterValues = window.alwaysShowFilterValues || {};
    if (!Object.keys(filterValues).length) return;

    const current = getCurrentFilters();
    Object.entries(filterValues).forEach(([label, values]) => {
      if (!Array.isArray(values) || !values.length) return;
      injectMissingValues(label, values, current[label] || null);
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after ANY Shopify/Ella filter AJAX update
  document.addEventListener('collection:rerender', init);
  document.addEventListener('filter:updated', init);
  document.addEventListener('shopify:section:load', init);

  // Watch for Ella's AJAX DOM replacement
  function observeFilterWrapper() {
    const wrapper = document.querySelector('#main-collection-filters');
    if (!wrapper) return;
    const observer = new MutationObserver(() => {
      // Small delay to let Shopify finish rendering
      setTimeout(init, 100);
    });
    observer.observe(wrapper, { childList: true, subtree: true });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeFilterWrapper);
  } else {
    observeFilterWrapper();
  }

})();